import { useEffect, useState } from 'react';

import { IInventory, InventoryField } from '@lamesarv-sdk/types';

interface DetailsNavbarProps {
  item: IInventory;
}

export const DetailsNavbar = ({ item }: DetailsNavbarProps) => {
  const [active, setActive] = useState<number>(0);

  const links = [
    {
      title: 'Overview',
      url: '#overview',
    },
    {
      title: 'Description',
      url: '#description',
    },
    {
      title: 'Floor Plan',
      url: '#floorplan',
    },
    // {
    //   title: 'Features',
    //   url: '#features',
    // },
    // {
    //   title: 'Specifications',
    //   url: '#specifications',
    // },
  ];

  if (!!item[InventoryField.videoUrl]) {
    links.splice(1, 0, { title: 'Video', url: '#video' });
  }

  useEffect(() => {
    const hashIndex = links.findIndex((link) => link.url === window.location.hash);
    setActive(hashIndex === -1 ? 0 : hashIndex);
  }, []);

  return (
    <div className="bg-neutral-700 px-4 md:px-6">
      <div className="container px-4 md:px-0 mx-auto py-4">
        <div className="flex flex-row flex-wrap gap-3 md:gap-4 items-center text-xs md:text-sm text-white">
          {links.map((link, index) => (
            <a
              key={link.title}
              href={link.url}
              className={`py-2 px-2 md:px-4 cursor-pointer ${
                active === index ? 'bg-white text-neutral-700' : 'border border-neutral-500 hover:bg-neutral-600'
              }`}
              onClick={() => setActive(index)}
            >
              {link.title}
            </a>
          ))}
        </div>
      </div>
    </div>
  );
};
